import React, { useState } from "react";
import {
  Modal,
  Box,
  Typography,
  IconButton,
  Button,
  Switch,
  LinearProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const steps = [
  {
    title: "Strictly Necessary Cookies",
    description:
      "We value your privacy. Our EHS & ESG solutions help you manage all processes and compliances. Mitigate risks and take the right actions for your net zero journey. We value your privacy.",
    alwaysActive: true,
  },

  {
    title: "Functional Cookies",
    description:
      "We value your privacy. Our EHS & ESG solutions help you manage all processes and compliances. Mitigate risks and take the right actions for your net zero journey. We value your privacy.",
    alwaysActive: false,
  },
  {
    title: "Performance Cookies",
    description:
      "We value your privacy , Our EHS & ESG solutions helps you manage all processes and compliances. Mitigate risks and take right actions for your net zero journey.  We value your privacy.",
    alwaysActive: false,
  },
  {
    title: "Targeting Cookies",
    description:
      "We value your privacy , Our EHS & ESG solutions helps you manage all processes and compliances. Mitigate risks and take right actions for your net zero journey.  We value your privacy.",
    alwaysActive: false,
  },
];

const CookieConsentModal = ({
  open,
  handleClose,
  onSave,
}) => {
  const [step, setStep] = useState(0);

  const [consent, setConsent] = useState(
    steps.map((item) => ({ title: item.title, active: item.alwaysActive }))
  );

  const handleToggle = (index) => {
    setConsent((prev) =>
      prev.map((item, i) =>
        i === index && i != 0 ? { ...item, active: !item.active } : item
      )
    );
  };


  const handleNext = () => {
    if (step < steps.length) setStep(step + 1);
  };

  const handlePrevious = () => {
    if (step > 0) setStep(step - 1);
  };

  const handleSavePreferences = () => {
    const preferences = {
      necessary: true,
      functional: consent[1].active,
      performance: consent[2].active,
      targeting: consent[3].active,
    };

    onSave(preferences);
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: 350, md: 700 },
          bgcolor: "background.paper",
          borderRadius: 3,
          boxShadow: 24,
          p: 3,
        }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center" mb="16px" >
          <Typography
            variant="h6"
            sx={{ color: "#61D1FA", pl: { xs: "38%", md: "45%" } }}
          >
            IENERGY®
          </Typography>
          <IconButton onClick={handleClose} >
            <CloseIcon sx={{ color: "#000" }} />
          </IconButton>
        </Box>
        <Typography sx={{ fontSize: { xs: "12px", md: "16px" }, color: "#B7B7B7", mb: 2, textAlign: { xs: "justify", md: "center" } }}>
          We value your privacy. Our EHS & ESG solutions help you manage all
          processes and compliances. Mitigate risks and take right actions for
          your net zero journey.
          <Typography
            component="span"
            sx={{ color: "#000", cursor: "pointer", textDecoration: "underline", fontSize: { xs: "12px", md: "16px" } }}
          >
            {" "}
            Privacy statement
          </Typography>
        </Typography>


        {step === steps.length ? (
          <>
            <Box sx={{ borderTop: "1px solid #D1D5DB", mt: 2, pt: 2 }}>
              {consent.map((item, index) => (
                <Box key={index} display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                  <Typography variant="subtitle1" >
                    {item.title}
                  </Typography>
                  {index === 0 ? (
                    <Typography sx={{ color: "#61D1FA", fontSize: 12 }}>Always Active</Typography>
                  ) : (
                    <Box display="flex" alignItems="center">
                      <Typography sx={{ fontSize: 12, color: item.active ? "#61D1FA" : "#B7B7B7" }}>
                        {item.active ? "Active" : "Inactive"}
                      </Typography>
                      <Switch
                        checked={item.active}
                        onChange={() => handleToggle(index)}
                        disabled={index === 0}
                        size="small"
                      />
                    </Box>
                  )}
                </Box>
              ))}
            </Box>

            <Box
              display="flex"
              flexDirection={{ xs: "column", md: "row" }}
              gap={2}
              justifyContent="space-between"
              mt={3}
            >
             <Button
  variant="contained"
  onClick={handleSavePreferences}
  sx={{
    bgcolor: "#07329F",
    color: "#fff",
    width: { xs: "100%", md: "48%" },
    textTransform: "none",
  }}
>
  Submit Preferences
</Button>
              <Button
  variant="contained"
  onClick={() =>
    onSave({
      necessary: true,
      functional: true,
      performance: true,
      targeting: true,
    })
  }
  sx={{
    bgcolor: "#07329F",
    color: "#fff",
    width: { xs: "100%", md: "48%" },
    textTransform: "none",
  }}
>
  Accept All Cookies
</Button>
            </Box>

          </>
        ) :
          <>
            <LinearProgress
              variant="determinate"
              value={(step / (steps.length - 1)) * 100}
              sx={{
                my: 2,
                height: 6, // Adjust thickness
                borderRadius: 5, // Rounded edges
                backgroundColor: "#E0E0E0", // Default track color
                "& .MuiLinearProgress-bar": {
                  backgroundColor: "#61D1FA", // Progress color
                  borderRadius: 5, // Rounded edges
                },
              }}
            />

            <Box
              display="flex"
              alignItems="center"
              justifyContent="flex-end"
              mt={1}
            >
              {steps[step].alwaysActive ? (
                <Typography variant="caption" sx={{ color: "#61D1FA" }}>
                  Always Active
                </Typography>
              ) : (
                <Box display="flex" alignItems="center">
                  <Typography variant="caption" sx={{ mr: 1 }}>
                    Inactive
                  </Typography>
                  <Switch size="small" checked={consent[step].active} onChange={() => handleToggle(step)} />
                </Box>
              )}
            </Box>

            <Typography variant="subtitle1" >
              {steps[step].title}
            </Typography>
            <Typography sx={{ fontSize: { xs: "12px", md: "16px" }, color: "#B7B7B7" }}>{steps[step].description}</Typography>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mt={3}

            >
              <Button
                onClick={handlePrevious}
                disabled={step === 0}
                sx={{ textTransform: "none", color: "#1D6FF2" }}
              >
                {"← Previous"}
              </Button>
              <Box display="flex" alignItems="center">
                <Button sx={{ textTransform: "none", textDecoration: "underline", mr: 2, color: "#000", cursor: "pointer" }}>Cookies Details</Button>
                <Button onClick={handleNext} sx={{ color: "#1D6FF2" }}>
                  {step === steps.length - 1 ? "Finish" : "Next →"}
                </Button>
              </Box>
            </Box>
          </>
        }
      </Box>
    </Modal>
  );
};

export default CookieConsentModal;

